module.exports = ".profilePicture {\n  height: 15vh;\n}\n\n.mat-form-field {\n  width: 90%;\n}\n\n.input-round {\n  width: 100%;\n}\n\n.padding-top5p {\n  padding-top: 5%;\n}\n\n.ss-btn-blue-solid {\n  border-radius: 7px !important;\n  width: 200px !important;\n  padding: 10px !important;\n}\n\n@media screen and (max-width: 500px) {\n  .mobile-center {\n    text-align: center !important;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/reusable/user-profile/user-profile.component.css
// module id = ./src/app/shared/reusable/user-profile/user-profile.component.css
// module chunks = main